module.exports = __webpack_public_path__ + "img/binance.d4af7308.png";